import React from "react";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";

const excludedOption: FilterMultiselectOption = {
    value: "excluded",
    label: "Excluded",
    searchableLabel: "excluded from 1099",
};

const includedOption: FilterMultiselectOption = {
    value: "included",
    label: "Included",
    searchableLabel: "included in 1099",
};

export const Exclude1099Filter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <TriStateBooleanFilter
        value={filters.excludeFrom1099}
        onChange={(excludeFrom1099) => onChange({ excludeFrom1099 })}
        trueOption={excludedOption}
        falseOption={includedOption}
        name="excludeFrom1099"
    />
);
